import ManageExamenFE from '@/views/consultations/en-cours/grossesse/examen-physique-fe/manage-examen-fe'
import store_fiche from "@/store/mods/consultations/fiche-consultations"
import $ from 'jquery'

export default {
    name: 'examen-physique-fe',
    components: {
        ManageExamenFE
    },
    props: {
        consultation: Object,
        section_name: String,
        evolution_id: Number,
        evolution_toggler: Number,
        current_consultation_evolution: Number,
        is_start: Number,
        user_info: Object
    },

    data() {
        return {
            is_loading: true,
            is_empty: false,
            info_user: {},
            grs_toggler: 0,
            group_id: 0,
            list_examens: [],
            selected_exam: [],
            data_to_be_deleted: {},
        }
    },

    watch: {
        evolution_toggler() {
            this.getData()
            this.userInfoSetter()
        }
    },

    computed: {

    },

    mounted() {
        
    },

    methods: {
        userInfoSetter() {
            this.info_user = {
                nom_medecin: this.user_info.user,
                titre: this.user_info.titre
            }
        },

        getData() {
            this.is_loading = true
            const data = {
                consultation_id: this.consultation.id,
                evolution_id: this.evolution_id,
                data_type: 'examen_femme_enceinte',
                est_en_cours: true
            }

            store_fiche.getCustomConsultationSectionData(data).then((response) => {
                console.log("Exm FE: ",response);
                
                this.list_examens = response
                if (response.length == 0) {
                    this.is_empty = true
                } else {
                    this.is_empty = false
                }
                
                this.is_loading = false
            })
        },

        addNew() {
            this.group_id = 0
            this.selected_exam = []
            
            this.grs_toggler = (this.grs_toggler == 0)?1:0
            $('#exm-phys-fe-'+this.evolution_id).modal('show')
        },


        editExmFE(data) {
            this.group_id = data.group_service_id
            this.selected_exam = data.fields

            this.grs_toggler = (this.grs_toggler == 0)?1:0
            $('#exm-phys-fe-'+this.evolution_id).modal('show')
        },

        removeExmFE(data) {
            this.data_to_be_deleted = {
                libelle: data.reference,
                consultation_id: this.consultation.id,
                evolution_id: this.evolution_id,
                user_id: this.user_info.id,
                group_id: data.group_service_id,
                data_type: 'examen_femme_enceinte'
            }
            console.log(this.data_to_be_deleted);
            

            $('.del-grp-exm'+this.evolution_id).modal('show')
        }
    }
}